module.exports = __webpack_public_path__ + "img/crash.568edb7c.png";